export const VERIFY_ACCOUNT_SAMPLE = {
  firstName: 'Rob',
  lastName: 'Michaels',
  email: 'rob.michaels@highair.com',
  verificationUrl: 'https://gotrustjet.com/verify?token=sample',
};
